import context from '../main.js'
import { getToken } from '@/utils/auth' // 验权

const ACCESS_PLATFORM = {
  wechat: 'wechat',
  alipay: 'alipay',
  other: 'other',
};

export function isLogin() {
  return getToken() ? true : false;
}

export function loginConfirm() {
  context.$router.push('/tryLogin');
  // context.$vux.confirm.show({
  //   // 组件除show外的属性
  //   title: '提示',
  //   content: '请登录后重试',
  //   "confirm-text": '去登录',
  //   onConfirm () {
  //     // console.log('去登录');
  //     context.$router.push('/tryLogin');
  //   }
  // }) 
}

class Browser {
  get type() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {  
      return ACCESS_PLATFORM.wechat;
    } else if(ua.match(/Alipay/i)=="alipay"){   
      return ACCESS_PLATFORM.alipay;
    }else{
      return ACCESS_PLATFORM.other;
    }
  }

  get accessAllowed() {
    console.log('浏览器类型', this.type);
    let res = this.type == ACCESS_PLATFORM.wechat || this.type == ACCESS_PLATFORM.alipay
    console.log(res);
    return this.type == ACCESS_PLATFORM.wechat || this.type == ACCESS_PLATFORM.alipay
  }
}
const browser = new Browser();
export {browser, ACCESS_PLATFORM}



// WEBPACK FOOTER //
// ./src/utils/util.js